// extracted by mini-css-extract-plugin
export default {"wrapper":"WideButton_wrapper__5jwQ9","title":"WideButton_title__b6NSC"};